import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import HotList from './components/HotList';
import SectionHeader from '@/components/feature/SectionHeader';
import MovieCard from '@/components/feature/MovieCard';
import SearchBox from '@/components/feature/SearchBox';
import { getFeaturedMovies, getHotMovies, getLatestMovies } from '@/lib/catalog';
import { siteStats } from '@/mocks/site';

export default function Home() {
  const featured = getFeaturedMovies();
  const latest = getLatestMovies(8);
  const hot = getHotMovies(6);

  return (
    <div className="mx-auto max-w-7xl px-4 py-6 md:px-8 md:py-8">
      <h1 className="sr-only">美女与野兽影视大全 - 最新电影与电视剧资源</h1>

      <HeroCarousel movies={featured} />

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[320px_1fr] lg:gap-8">
        <aside className="flex flex-col gap-6">
          <CategoryEntries />
          <HotList movies={hot} />
        </aside>

        <div>
          <SectionHeader
            title="最新上映"
            subtitle="近期上映的电影与开播剧集，按上映时间排序"
            moreTo="/category/movie"
            moreLabel="更多电影"
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 xl:grid-cols-4">
            {latest.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>

          <div className="mt-8 rounded-lg border border-background-200 bg-primary-50 p-6">
            <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
              <div className="max-w-md">
                <h2 className="font-heading text-xl font-bold text-foreground-950">
                  不知道看什么？搜一下
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  输入片名、演员或关键词，快速找到想看的电影与电视剧。
                </p>
              </div>
              <div className="w-full lg:max-w-sm">
                <SearchBox size="lg" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="mt-12 rounded-lg border border-background-200 bg-background-100 p-6 md:p-10">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.2fr_1fr] lg:items-center">
          <div>
            <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 font-label text-xs font-semibold text-accent-900">
              <i className="ri-bookmark-line" aria-hidden="true" />
              关于平台
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              把每一个好故事，讲给懂它的人
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              「美女与野兽」是一个专注于影视资源展示与推荐的平台。我们整理了电影与电视剧的剧情介绍、
              主创与演员资料，以及最新的上映与热播资讯，帮助影迷、影评人与追剧用户快速找到想看的内容。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              平台内容每日整理更新，支持按类型、年份、地区筛选，也支持关键词搜索与本地收藏，方便你随时回顾心仪的作品。
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {siteStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200 bg-background-50 p-4"
              >
                <p className="font-heading text-2xl font-black text-primary-600">{stat.value}</p>
                <p className="mt-1 font-label text-xs text-foreground-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}